import React, { useCallback } from 'react';

import Hubspot from 'main/common/Hubspot';
import { Period, Plan } from 'pages/Landings/sections/Pricing/types';
import { useUserInfo } from 'queries/user-action/use-user-info';

import PlanSummary from '../Summary';

interface Props {
    period: Period;
    className?: string;
}

const BasicPlanSummary: React.FC<Props> = ({ period, className }) => {
    const { data: user } = useUserInfo();
    const isAnnual = period === Period.ANNUALLY;

    const onClick = useCallback(() => {
        if (user) {
            Hubspot.send(Hubspot.PRICING_CLICK, { email: user.email });
        }
    }, [user]);

    return (
        <PlanSummary
            name="Basic"
            price={
                isAnnual
                    ? { primary: '$475', secondary: 'per month', minor: '$5 700 annually' }
                    : { primary: '$600', secondary: 'per month' }
            }
            button={{
                text: 'Request invoice',
                to: `/checkout?license=${Plan.BASIC}&annual=${isAnnual}`,
                onClick
            }}
            className={className}
        />
    );
};

export default BasicPlanSummary;
